
import Footer from './component/Footer';
import Homepage from './component/Homepage';
import { Navbar } from './component/Navbar';
import Dropdown from "./component/Dropdown"
import Navbar2 from './component/Navbar2';
import SingUpPage from './component/SingUpPage';
import LoginPage from './component/LoginPage';
import { AllRoutes } from './AllRoutes';
import SingleUser from './component/SingleUser';

function App() {
  return (
    <div >
    <AllRoutes />
    </div>
  );
}

export default App;
